export enum Module {
    NOTIFICATION = 1,
    WAIT_TIME = 2,
    PROVIDER = 3,
    PATIENT = 4,
    SCHEDULE = 5,
    DATA_LOG = 6,
    DOCUMENT = 7,
    MASTER_SCHEDULE = 9,
  }